import { useState, useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import AsyncSelect from "react-select/async";
import Sidebar from "../../sidebar/sidebar";
import TopBar from "../../topbar/TopBar";
import DOMPurify from "dompurify";
import SearchWithAPI from "../../searchbox/searchbox.js";

import { Toast, ToastContainer } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { alertSubmitApi, getGateListApi, getalertDetailsApi, getTypeListApi, getEditConfigApi, updateConfigApi, getDeleteFieldsApi } from "./alertConfigure-api.js";
import PoweredBy from "../../common/poweredBy.jsx";

export default function AlertconfigurationAdd() {
  const navigate = useNavigate();

  const location = useLocation();
  const { gateId } = location.state || {};

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const apiUrl = process.env.REACT_APP_API_URL;

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  //Gate
  const [gate, setGate] = useState([]);
  const fetchGate = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getGateListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleGateChange = (selectedOptions) => {
    setGate(selectedOptions);
  };

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [sideTab, setSideTab] = useState({ label: "", value: "" });
  const [alertConfigList, setalertConfigList] = useState([]);
  // Per-type select states
  const [emailConfig, setEmailConfig] = useState({});
  const [emailTemp, setEmailTemp] = useState({});
  const [smsConfig, setSmsConfig] = useState({});
  const [smsConfigTemp, setSmsTemp] = useState({});
  const [whatsappConfig, setWhatsappConfig] = useState({});
  const [whatsappConfigTemp, setWhatsappTemp] = useState({});
  const [pushConfigTemp, setPushTemp] = useState({});

  const [validations, setValidations] = useState({
    name: "",
    docks: "",
    code: "",
    fields: "",
  });

  const handleEmailConfig = (option) => {
    setEmailConfig((prev) => ({ ...prev, [sideTab.value]: option }));
    setAlertTypeConfigs((prev) => ({
      ...prev,
      [sideTab.value]: {
        ...prev[sideTab.value],
        email_config_id: option?.value || "0",
      },
    }));
  };

  const handleEmailTemp = (option) => {
    setEmailTemp((prev) => ({ ...prev, [sideTab.value]: option }));
    setAlertTypeConfigs((prev) => ({
      ...prev,
      [sideTab.value]: {
        ...prev[sideTab.value],
        email_template_id: option?.value || "0",
      },
    }));
  };

  const handleSmsConfig = (option) => {
    setSmsConfig((prev) => ({ ...prev, [sideTab.value]: option }));
    setAlertTypeConfigs((prev) => ({
      ...prev,
      [sideTab.value]: {
        ...prev[sideTab.value],
        sms_config_id: option?.value || "0",
      },
    }));
  };

  const handleSmsTemp = (option) => {
    setSmsTemp((prev) => ({ ...prev, [sideTab.value]: option }));
    setAlertTypeConfigs((prev) => ({
      ...prev,
      [sideTab.value]: {
        ...prev[sideTab.value],
        sms_template_id: option?.value || "0",
      },
    }));
  };

  const handleWhatsappConfig = (option) => {
    setWhatsappConfig((prev) => ({ ...prev, [sideTab.value]: option }));
    setAlertTypeConfigs((prev) => ({
      ...prev,
      [sideTab.value]: {
        ...prev[sideTab.value],
        whatsapp_config_id: option?.value || "0",
      },
    }));
  };

  const handleWhatsappTemp = (option) => {
    setWhatsappTemp((prev) => ({ ...prev, [sideTab.value]: option }));
    setAlertTypeConfigs((prev) => ({
      ...prev,
      [sideTab.value]: {
        ...prev[sideTab.value],
        whatsapp_template_id: option?.value || "0",
      },
    }));
  };

  const handlePushTemp = (option) => {
    setPushTemp((prev) => ({ ...prev, [sideTab.value]: option }));
    setAlertTypeConfigs((prev) => ({
      ...prev,
      [sideTab.value]: {
        ...prev[sideTab.value],
        app_notification_template_id: option?.value || "0",
      },
    }));
  };

  const [alertTypeConfigs, setAlertTypeConfigs] = useState({});

  const handleToggle = (type, key) => {
    setAlertTypeConfigs((prev) => {
      const currentConfig = prev[type] || {
        type: type,
        email_enabled: false,
        email_config_id: "0",
        email_template_id: "0",
        sms_enabled: false,
        sms_config_id: "0",
        sms_template_id: "0",
        whatsapp_enabled: false,
        whatsapp_config_id: "0",
        whatsapp_template_id: "0",
        call_enabled: false,
        call_config_id: "0",
        call_template_id: "0",
        app_notification_enabled: false,
        app_notification_template_id: "0",
      };

      return {
        ...prev,
        [type]: {
          ...currentConfig,
          [`${key}_enabled`]: !currentConfig[`${key}_enabled`],
        },
      };
    });
  };

  const submitform = async () => {
    const fields = Object.values(alertTypeConfigs).map((config) => ({
      type: config.type,
      email_enabled: config.email_enabled,
      email_config_id: config.email_config_id || "0",
      email_template_id: config.email_template_id || "0",
      sms_enabled: config.sms_enabled,
      sms_config_id: config.sms_config_id || "0",
      sms_template_id: config.sms_template_id || "0",
      whatsapp_enabled: config.whatsapp_enabled,
      whatsapp_config_id: config.whatsapp_config_id || "0",
      whatsapp_template_id: config.whatsapp_template_id || "0",
      call_enabled: config.call_enabled,
      call_config_id: config.call_config_id || "0",
      call_template_id: config.call_template_id || "0",
      app_notification_enabled: config.app_notification_enabled,
      app_notification_template_id: config.app_notification_template_id || "0",
    }));

    const dataBeforeSanitize = {
      name: name,
      code: code,
      docks: gate.map((item) => item.value),
      fields: fields,
    };

    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });

    try {
      let response;
      if (!gateId) {
        // Create new
        response = await alertSubmitApi(dataAfterSanitize);
      } else {
        // Update existing
        response = await updateConfigApi(gateId, dataAfterSanitize);
      }

      if (response.status === 200 && response.data.success === true) {
        setSnackbarMessage(response.data.message || "Operation successful");
        setSnackbarStatus(true);
        handleSnackbarShow();

        // Navigate after short delay to show snackbar
        setTimeout(() => {
          navigate("/alertconfiguration");
        }, 1000);
      } else if (response === 400) {
        const validationTemp = {
          name: "",
          docks: "",
          code: "",
          fields: "",
        };

        Object.entries(response.data.error).forEach(([key, value]) => {
          validationTemp[key] = Array.isArray(value) ? value[0] : value;
        });

        setValidations(validationTemp);
        setSnackbarMessage("Please fix the validation errors");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSnackbarMessage("An error occurred");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };

  // // Handle delete
  // const handleDelete = async (id) => {
  //   try {
  //     const response = await getDeleteFieldsApi(id);
  //     if (response.status === 200 && response.data.success) {
  //       setSnackbarMessage("Configuration deleted successfully");
  //       setSnackbarStatus(true);
  //       handleSnackbarShow();

  //       setTimeout(() => {
  //         navigate("/alertconfigurations");
  //       }, 1000);
  //     }
  //   } catch (error) {
  //     console.error("Error deleting configuration:", error);
  //     setSnackbarMessage("Error deleting configuration");
  //     setSnackbarStatus(false);
  //     handleSnackbarShow();
  //   }
  // };

  // Initialize default alert types
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAlertTypes = async () => {
      try {
        const response = await getTypeListApi("");
        if (response?.status === 200 && response?.data?.success) {
          const types = response.data.suggestionlist;
          if (Array.isArray(types) && types.length > 0) {
            setalertConfigList(types);
            setSideTab(types[0]);
          }
        }
      } catch (error) {
        console.error("Error fetching alert types:", error);
        setalertConfigList([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAlertTypes();
  }, []);

  const fetchEditData = async (gateId) => {
    try {
      const response = await getEditConfigApi(gateId);
      console.log("Edit data response:", response);

      if (response?.status === 200 && response?.data?.success === true) {
        const data = response?.data?.config;

        if (data) {
          setName(data.name || "");
          setCode(data.code || "");

          setGate(
            data.gates.map((dock) => ({
              value: String(dock.value),
              label: dock.label,
            })) || []
          );

          const configsByType = {};
          data.fields.forEach((field) => {
            configsByType[field.type] = {
              type: field.type,
              email_enabled: field.email_enabled === 1,
              email_config_id: field.email_config_id,
              email_template_id: field.email_template_id,
              sms_enabled: field.sms_enabled === 1,
              sms_config_id: field.sms_config_id,
              sms_template_id: field.sms_template_id,
              whatsapp_enabled: field.whatsapp_enabled === 1,
              whatsapp_config_id: field.whatsapp_config_id,
              whatsapp_template_id: field.whatsapp_template_id,
              call_enabled: field.call_enabled === 1,
              call_config_id: field.call_config_id,
              call_template_id: field.call_template_id,
              app_notification_enabled: field.app_notification_enabled === 1,
              app_notification_template_id: field.app_notification_template_id,
            };
          });

          setAlertTypeConfigs(configsByType);

          data.fields.forEach((field) => {
            if (field.email_config_id) {
              setEmailConfig((prev) => ({ ...prev, [field.type]: { value: field.email_config_id, label: field.email } }));
            }
            if (field.sms_config_id) {
              setSmsConfig((prev) => ({ ...prev, [field.type]: { value: field.sms_config_id, label: field.sms } }));
            }
            if (field.whatsapp_config_id) {
              setWhatsappConfig((prev) => ({ ...prev, [field.type]: { value: field.whatsapp_config_id, label: field.whatsapp } }));
            }
            if (field.email_template_id) {
              setEmailTemp((prev) => ({ ...prev, [field.type]: { value: field.email_template_id, label: field.email_template } }));
            }
            if (field.sms_template_id) {
              setSmsTemp((prev) => ({ ...prev, [field.type]: { value: field.sms_template_id, label: field.sms_template } }));
            }
            if (field.whatsapp_template_id) {
              setWhatsappTemp((prev) => ({ ...prev, [field.type]: { value: field.whatsapp_template_id, label: field.whatsapp_template } }));
            }
            if (field.app_notification_template_id) {
              setPushTemp((prev) => ({ ...prev, [field.type]: { value: field.app_notification_template_id, label: field.app_notification } }));
            }
          });
        }
      }
    } catch (error) {
      console.error("Error fetching edit data:", error);
    }
  };

  // Load edit data when gateId changes
  useEffect(() => {
    if (gateId != null) {
      fetchEditData(gateId);
    }
  }, [gateId]);

  const keyframesStyle = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

  return (
    <div style={{ fontFamily: "Epilogue" }}>
      <div>
        <TopBar />
      </div>
      <div style={{ display: "flex" }}>
        <div>
          <Sidebar activeMenu={"Alert Configuration"} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "24px", backgroundColor: "#FFFFFF" }}>
          <Row className="my-4 align-items-center">
            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>

            <Col>
              <div style={{ fontWeight: 400, fontSize: 13, color: "#8790A1", whiteSpace: "nowrap" }}>Set up your organization with these master settings and manage them seamlessly from here.</div>
            </Col>

            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>
            <div style={{ marginBottom: "40px" }}>
              <Row className="align-items-center" style={{ marginBottom: "32px" }}>
                <Col xs={12} md={6}>
                  <div style={{ fontWeight: "700", fontSize: "20px", color: "#172b4d" }}>Create New Alert Template</div>
                </Col>
                <Col xs={12} md={6}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "12px", flexWrap: "wrap" }}>
                    <button style={{ borderRadius: "10px", height: "44px", border: "1px solid #e5e5e5", padding: "10px 32px", backgroundColor: "#ffffff", fontWeight: "700", fontSize: "14px", color: "#172b4d", cursor: "pointer" }} onClick={() => navigate("/alertconfiguration")}>
                      Cancel
                    </button>
                    <button onClick={() => submitform()} style={{ borderRadius: "10px", border: "none", height: "44px", padding: "10px 32px", backgroundColor: "#2c8c53", fontWeight: "700", fontSize: "14px", color: "#ffffff", cursor: "pointer" }}>
                      Save
                    </button>
                  </div>
                </Col>
              </Row>

              <Row style={{ width: "100%" }}>
                <Col sm={12} md={6} lg={3}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>
                      Code <span style={{ color: "#ff4444" }}>*</span>
                    </div>
                    <div>
                      <input type="text" placeholder="Enter code" value={code} onChange={(e) => setCode(e.target.value)} style={{ border: "1.3px solid #E5E5E5", borderRadius: "10px", padding: "16px", height: "40px", backgroundColor: "#ffffff", fontWeight: "400", fontSize: "13px", color: "#8790A1", width: "100%" }} />
                      <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.code}</span>
                    </div>
                  </div>
                </Col>

                <Col sm={12} md={6} lg={3}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>
                      Template Name <span style={{ color: "#ff4444" }}>*</span>
                    </div>
                    <div>
                      <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder="Enter code" style={{ border: "1.3px solid #E5E5E5", borderRadius: "10px", padding: "16px", height: "40px", backgroundColor: "#ffffff", fontWeight: "400", fontSize: "13px", color: "#8790A1", width: "100%" }} />
                      <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.name}</span>
                    </div>
                  </div>
                </Col>

                <Col sm={12} md={6} lg={3}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>Gate</div>
                    <div>
                      <AsyncSelect isMulti cacheOptions value={gate} loadOptions={fetchGate} onChange={handleGateChange} defaultOptions placeholder="Search gate..." styles={multiselectCustomStyles} isClearable={false} />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Row>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "stretch", height: "100%" }}>
            <div>
              <div style={{ fontWeight: "700", fontSize: "20px", color: "#172b4d", marginTop: "-10px" }}>Alert Configuration ({isLoading ? "..." : alertConfigList.length})</div>
              <div style={{ maxHeight: "56%", overflowY: "auto" }}>
                {isLoading ? (
                  <div style={{ textAlign: "center", marginTop: "100px" }}>
                    <div style={{ border: "4px solid #2c8c53", borderTop: "4px solid transparent", borderRadius: "50%", width: "40px", height: "40px", animation: "spin 1s linear infinite", margin: "0 auto 10px" }}></div>
                    <div style={{ color: "#2c8c53" }}>Loading...</div>
                    <style>{keyframesStyle}</style>
                  </div>
                ) : (
                  <>
                    <div style={{ display: "flex", alignItems: "center", borderLeft: "1px dashed #626F86" }}>
                      <div style={{ border: "1px dashed #626F86", width: "20px", height: "0px", visibility: "hidden" }}></div>
                      <div style={{ borderRadius: "8px", visibility: "hidden" }}>Visitor gate-in</div>
                    </div>
                    {alertConfigList.map((value) => (
                      <div
                        key={value.label}
                        style={{ display: "flex", alignItems: "center", borderLeft: "1px dashed #626F86", cursor: "pointer" }}
                        onClick={() => {
                          setSideTab(value);
                        }}
                      >
                        <div style={{ border: "1px dashed #626F86", width: "20px", height: "0px" }}></div>
                        <div style={{ borderRadius: "8px", padding: "10px 8px 10px 12px", backgroundColor: sideTab.label === value.label ? "#F3FFF8" : "", border: sideTab.label === value.label ? "1px dashed #2c8c53" : "", color: sideTab.label === value.label ? "#2c8c53" : "#000", transition: "all 0.2s ease-in-out", width: "100%" }}>{value.label}</div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
            <div style={{ borderRadius: "16px", padding: "20px 16px 16px 16px", backgroundColor: "#F8F8F8", display: "flex", flexDirection: "column", gap: "12px", width: "75%", height: "90%" }}>
              <div style={{ marginTop: "6px", fontWeight: "700", fontSize: "14px", color: "#2c8c53", textAlign: "center" }}>{sideTab?.label?.toUpperCase?.() || ""}</div>

              <div>
                <div style={{ marginBottom: "12px", fontWeight: "600", fontSize: "13px", color: "#8790A1" }}>Configurations</div>

                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  <div style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "700", fontSize: "16px", color: "#174b4d" }}>Email</div>
                      <div>
                        <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                          <input type="checkbox" checked={alertTypeConfigs[sideTab.value]?.email_enabled} onChange={() => handleToggle(sideTab.value, "email")} style={{ opacity: 0, width: 0, height: 0 }} />
                          <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: alertTypeConfigs[sideTab.value]?.email_enabled ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                          <span style={{ position: "absolute", height: "18px", width: "18px", left: alertTypeConfigs[sideTab.value]?.email_enabled ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                        </label>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Email</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleEmailConfig} disabled={!alertTypeConfigs[sideTab.value]?.email_enabled} apiUrl={apiUrl + "get_email_config"} params={{}} placeholder={"Select"} selectedOption={emailConfig[sideTab.value] || null} />
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Template</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleEmailTemp} disabled={!alertTypeConfigs[sideTab.value]?.email_enabled} apiUrl={apiUrl + "email_template/autosuggestion"} params={{}} placeholder="Select" selectedOption={emailTemp[sideTab.value] || null} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "700", fontSize: "16px", color: "#174b4d" }}>SMS</div>
                      <div>
                        <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                          <input type="checkbox" checked={alertTypeConfigs[sideTab.value]?.sms_enabled} onChange={() => handleToggle(sideTab.value, "sms")} style={{ opacity: 0, width: 0, height: 0 }} />
                          <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: alertTypeConfigs[sideTab.value]?.sms_enabled ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                          <span style={{ position: "absolute", height: "18px", width: "18px", left: alertTypeConfigs[sideTab.value]?.sms_enabled ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                        </label>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>SMS</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleSmsConfig} disabled={!alertTypeConfigs[sideTab.value]?.sms_enabled} apiUrl={apiUrl + "get_sms_config"} params={{}} placeholder={"Select"} selectedOption={smsConfig[sideTab.value] || null} />
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Template</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleSmsTemp} disabled={!alertTypeConfigs[sideTab.value]?.sms_enabled} apiUrl={apiUrl + "email_template/autosuggestion"} params={{ type: sideTab.value, medium: "sms" }} placeholder="Select" selectedOption={smsConfigTemp[sideTab.value] || null} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "700", fontSize: "16px", color: "#174b4d" }}>Push Notification</div>
                      <div>
                        <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                          <input type="checkbox" checked={alertTypeConfigs[sideTab.value]?.app_notification_enabled} onChange={() => handleToggle(sideTab.value, "app_notification")} style={{ opacity: 0, width: 0, height: 0 }} />
                          <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: alertTypeConfigs[sideTab.value]?.app_notification_enabled ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                          <span style={{ position: "absolute", height: "18px", width: "18px", left: alertTypeConfigs[sideTab.value]?.app_notification_enabled ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                        </label>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Template</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handlePushTemp} disabled={!alertTypeConfigs[sideTab.value]?.app_notification_enabled} apiUrl={apiUrl + "email_template/autosuggestion"} params={{ type: sideTab.value, medium: "app-notification" }} placeholder="Select" selectedOption={pushConfigTemp[sideTab.value] || null} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", gap: "24px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ fontWeight: "700", fontSize: "16px", color: "#174b4d" }}>Whatsapp</div>
                      <div>
                        <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                          <input type="checkbox" checked={alertTypeConfigs[sideTab.value]?.whatsapp_enabled} onChange={() => handleToggle(sideTab.value, "whatsapp")} style={{ opacity: 0, width: 0, height: 0 }} />
                          <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: alertTypeConfigs[sideTab.value]?.whatsapp_enabled ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                          <span style={{ position: "absolute", height: "18px", width: "18px", left: alertTypeConfigs[sideTab.value]?.whatsapp_enabled ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                        </label>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Whatsapp</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleWhatsappConfig} disabled={!alertTypeConfigs[sideTab.value]?.whatsapp_enabled} apiUrl={apiUrl + "get_whatsapp_config"} params={{}} placeholder={"Select"} selectedOption={whatsappConfig[sideTab.value] || null} />
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
                        <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Template</div>
                        <div style={{ width: "100%" }}>
                          <SearchWithAPI onDropdownChange={handleWhatsappTemp} disabled={!alertTypeConfigs[sideTab.value]?.whatsapp_enabled} apiUrl={apiUrl + "email_template/autosuggestion"} params={{ type: sideTab.value, medium: "whatsapp" }} placeholder="Select" selectedOption={whatsappConfigTemp[sideTab.value] || null} />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button onClick={() => submitform()} style={{ borderRadius: "100px", border: "1px solid #E5E5E5", padding: "10px 28px", backgroundColor: "#D35258", fontWeight: "700", fontSize: "14px", width: "160px", color: "#FFFFFF", cursor: "pointer" }}>
                      Update
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

        </div>

        <ToastContainer position="top-end">
          <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
            <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </div>
  );
}
